import { styled } from '../theme';

type Props = {
    stripes?: boolean;
};

const Table = styled('table')<Props>(({ theme, stripes }) => ({
    width: '100%',
    tableLayout: 'auto',
    fontFamily: theme.typography.fontFamily.medium,
    color: theme.color.jetBlack,
    ...(stripes && {
        'tbody tr:nth-of-type(odd)': {
            background: theme.color.tableZebraStripeGray,
        },
    }),
}));

export default Table;
